import React, { Component } from 'react'

import { connect } from 'react-redux'

import Checkbox from './Checkbox'

import { toggleDIDAddOn } from '../store/actions/DIDsActions'

class DIDAddOns extends Component {

    toggleDIDAddOn(addOnName) {
        const { DID } = this.props;
        this.props.toggleDIDAddOn(DID, addOnName);
    }

    render() {
        const { isVisible = false, toggles = {} } = this.props;
        return (
            <tbody style={{display: (isVisible ? "table-row-group" : "none")}}>
                <tr>
                    <td colSpan="3" style={{padding: "0"}}>
                        <table>
                            <tbody className="nested-table">
                                <tr>
                                    <th>411*
                                    <div style={{fontWeight: "500"}}>$0.99/month <span style={{fontSize: ".85rem"}}>(+$4.99 Setup)</span></div>

                                    </th>
                                    <th>E911*
                                    <div style={{fontWeight: "500"}}>$5.99/month</div>

                                    </th>
                                    <th>CName*
                                    <div style={{fontWeight: "500"}}>$2.99/month</div>

                                    </th>
                                    {/*<th>SMS Package
                                    <div style={{fontWeight: "500"}}>$4.99/m</div>

                                    </th>*/}
                                </tr>
                                <tr>
                                    <td>
                                        <Checkbox active={!!toggles["411"]} 
                                            onChange={() => this.toggleDIDAddOn("411")} />
                                    </td>
                                    <td>
                                        <Checkbox active={!!toggles["E911"]} 
                                            onChange={() => this.toggleDIDAddOn("E911")} />
                                    </td>
                                    <td>
                                        <Checkbox active={!!toggles["CName"]} 
                                            onChange={() => this.toggleDIDAddOn("CName")} />
                                    </td>
                                    {/*<td>
                                        <Checkbox />
                                    </td>*/}
                                </tr>
                            </tbody>
                            {/*<tbody className="nested-table">
                                <tr>
                                    <td style={{fontWeight:"bold", textAlign: "center", verticalAlign: "middle"}}>
                                        <div style={{fontSize: "1.25rem"}}>
                                        Optional Features:
                                        </div>
                                        <div style={{fontWeight: "500", fontSize: ".95rem !important"}}>(Configured after purchase)</div>
                                    </td>
                                    <td style={{fontWeight:"bold", textAlign: "center", verticalAlign: "middle"}}>
                                        411 <Checkbox style={{display: "inline"}} />
                                        <div style={{fontWeight: "500"}}>$0.99/month + Setup $4.99</div>
                                    </td>
                                    <td style={{fontWeight:"bold", textAlign: "center", verticalAlign: "middle"}}>
                                        E911 <Checkbox style={{display: "inline"}} />
                                        <div style={{fontWeight: "500"}}>$5.99/month</div>
                                    </td>
                                    <td style={{fontWeight:"bold", textAlign: "center", verticalAlign: "middle"}}>
                                        CName <Checkbox style={{display: "inline"}} />
                                        <div style={{fontWeight: "500"}}>$2.99/month</div>
                                    </td>
                                    <td style={{fontWeight:"bold", textAlign: "center", verticalAlign: "middle"}}>
                                        SMS Package <Checkbox style={{display: "inline"}} />
                                        <div style={{fontWeight: "500"}}>$4.99/m</div>
                                    </td>
                                </tr>
                            </tbody>*/}
                        </table>
                    </td>
                </tr>
            </tbody>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        data: state.DIDsReducer
    }
}
const mapDispatchToProps = (dispatch) => {
    return {
        toggleDIDAddOn: (DID, addOnName) => dispatch(toggleDIDAddOn(DID, addOnName)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(DIDAddOns);